import api from './api';

interface IVacancyGroupAPIPayload {
  title: string;
  description: string;
  division: string;
}

async function createVacancyGroupAPI(payload: IVacancyGroupAPIPayload) {
  const response = await api.post('group/', payload);
  return response?.data;
}

export default createVacancyGroupAPI;
